import { isMobile, isTablet } from '../../utils/screenSizes';

const THIRD_PARTY_NO_AD_EVENT = 'collapse ad';
const DESKTOP_AD_UNIT_PATH_PREFIX = '7449/Trulia';
const MOBILE_AD_UNIT_PATH_PREFIX = '7449/Trulia_Phone_Mweb';
const TABLET_AD_UNIT_PATH_PREFIX = '7449/Trulia_Tablet_Mweb';
const PDP_MOANA_ADS = 'pdp_moana';
const INDEX_EXCHANGE_KEY = 'IX';
const MAGNITE_KEY = 'Mag';

const getThirdPartyNoAdActionAdUnitPath = (evt) => {
  if (evt && evt.data && (typeof evt.data === 'string')) {
    const eventData = evt.data.split(':');
    const eventName = eventData[0];
    if ((eventName === THIRD_PARTY_NO_AD_EVENT)
      && eventData.length > 1) {
      const adUnitPath = eventData[1].trim();
      return adUnitPath;
    }
  }
};

// Convert to ucword
const getNormalListingType = (text) => {
  return text.split('_').map((word) => {
    return word.toLowerCase().replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, (char) => char.toUpperCase());
  }).join('_');
};

const getAdUnitPrefix = (breakpoint, listtp) => {
  const listingType = getNormalListingType(listtp);

  let adUnitPrefix = DESKTOP_AD_UNIT_PATH_PREFIX;
  if (isMobile(breakpoint)) {
    adUnitPrefix = MOBILE_AD_UNIT_PATH_PREFIX;
  }
  if (isTablet(breakpoint)) {
    adUnitPrefix = TABLET_AD_UNIT_PATH_PREFIX;
  }

  return `${adUnitPrefix}/Property_Details/${listingType}`;
};

const getFormattedAdTargetings = (adTargetings, isPrebidAds) => {
  const formattedAdTargetings = adTargetings.reduce((result, adTargeting) => {
    const { key, value } = adTargeting;
    result[key] = value;
    return result;
  }, {});

  const AdsRequestServerKey = !isPrebidAds ? INDEX_EXCHANGE_KEY : MAGNITE_KEY;

  if (Array.isArray(formattedAdTargetings.vers)) {
    formattedAdTargetings.vers.push(PDP_MOANA_ADS);
    formattedAdTargetings.vers.push(AdsRequestServerKey);
  } else {
    formattedAdTargetings.vers =  [ PDP_MOANA_ADS, AdsRequestServerKey ];
  }

  return formattedAdTargetings;
};

const getAdUnitPath = (targetings, breakpoint) => {
  const formattedAdTargetings = getFormattedAdTargetings(targetings);
  return getAdUnitPrefix(breakpoint, formattedAdTargetings['listtp']);
};

export {
  getFormattedAdTargetings,
  getAdUnitPath,
  getThirdPartyNoAdActionAdUnitPath,
};
